import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";

function idsToStr(arr) {
  return (arr || []).join(", ");
}

function strToIds(s) {
  return s
    .split(",")
    .map((x) => x.trim())
    .filter(Boolean);
}

export function LinkRegistryEditor({ links, onChange }) {
  const l = links || {};

  const field = (key, label) => (
    <div key={key}>
      <Label className="text-xs">{label}</Label>
      <Input
        className="mt-1 h-8 text-xs"
        value={idsToStr(l[key])}
        onChange={(e) => onChange({ ...l, [key]: strToIds(e.target.value) })}
        placeholder="id_one, id_two"
      />
    </div>
  );

  return (
    <div className="grid gap-2 sm:grid-cols-2" data-testid="link-registry-editor">
      {field("deity_ids", "Deities")}
      {field("festival_ids", "Festivals")}
      {field("vrata_ids", "Vratas")}
      {field("story_ids", "Stories")}
      {field("sadhana_ids", "Sādhanas")}
    </div>
  );
}
